import React from 'react';

import SlaDiscrepanciesCreator from '../components/sla-discrepancies/creator';

class NewSlaDiscrepanciesPage extends React.Component {

    constructor(props){
        super(props)
    }

    render(){
        return (
            <SlaDiscrepanciesCreator slaId={this.props.match.params.slaId}/>
        )
	}

}

export default NewSlaDiscrepanciesPage;


// WEBPACK FOOTER //
// ./src/containers/new-sla-discrepancies-page.js